import React, { useEffect, useState } from "react";
import logo from "../../assets/Logo/Logo-Full-Light.png";
import { NavbarLinks } from "../../data/navbar-links";
import { Link, matchPath } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProfileDropdown from "../core/Auth/ProfileDropdown";
import { ACCOUNT_TYPE } from "../../utils/constants";
import {CiShoppingCart } from 'react-icons/ci'
import { apiConnector } from "../../services/apiconnector";
import { categories } from '../../services/apis'
import { MdOutlineKeyboardArrowDown } from "react-icons/md"
import { AiOutlineMenu } from "react-icons/ai";
import Spinner from "./Spinner";
import { logout } from "../../services/operations/authAPI";

const Navbar = () => {
  const {user} = useSelector((state)=>state.profile);
  const {token} = useSelector((state)=> state.auth);
  const {totalItems} = useSelector((state)=>state.cart)
  const [subLinks,setSubLinks] = useState([]);
  const [loading,setLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch()
  

  const fetchSublinksData = async()=>{
    setLoading(true)
    try{
      const result = await apiConnector("GET",categories.CATEGORIES_API)
      console.log("Printing sublinks result : ",result);
      if(result){
        setSubLinks(result?.data?.data);
      }
    }catch(err){
      console.log("Could not fetch all categories data")
    }
    setLoading(false);
  }
  useEffect(()=>{
    fetchSublinksData();
  },[])
  
  const matchRoutes = (route) => {
    return matchPath({ path: route }, location.pathname);
  };
  return (
    <div
      className={`flex h-14 items-center justify-center border-b-[1px] border-b-richblack-700 ${
        location.pathname !== "/" ? "bg-richblack-800" : ""
      } transition-all duration-200`}
    >
      <div className="flex w-11/12 max-w-maxContent items-center justify-between">
        {/* logo  */}
        <Link to="/">
          <img src={logo} alt="" width={160} height={32} loading="lazy" />
        </Link>
        {/* Navigation links  */}
        <nav className="hidden md:block">
          <ul className="flex gap-x-6 text-richblack-25">
            {NavbarLinks.map((link, index) => (
              <li key={index}>
                {link.title === "Catalog" ? (
                  <div className={`group relative flex cursor-pointer items-center gap-1 ${
                    matchRoutes("/catalog/:catalogName")
                      ? "text-yellow-25"
                      : "text-richblack-25"
                  }`}>
                    {link.title}
                    <MdOutlineKeyboardArrowDown/>
                    <div className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em] flex-col rounded-lg bg-richblack-5 p-4 text-richblack-900 opacity-0 transition-all duration-150 group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]">

                      <div className="absolute left-[50%] top-0 -z-10 h-6 w-6 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5">
                      </div>
                      {console.log("PRINTING SUBLINKS",subLinks)}
                      {
                        loading 
                        ? (<Spinner/>)
                        : ( subLinks.length > 0 && 
                            // subLinks.filter((subLink)=>subLink?.courses?.length > 0)
                            subLinks.map((subLink,index)=>(
                              <Link to={`/catalog/${subLink.name
                                .split(" ")
                                .join("-")
                                .toLowerCase()}`} 
                                className="rounded-lg bg-transparent py-4 pl-4 hover:bg-richblack-50"
                                key={index}>
                                  <p>
                                    {subLink.name}
                                  </p>
                              </Link>
                            ))
                            // <div>Data aaega</div>
                        )
                      }
                    </div>
                  </div>
                ) : (
                  <Link to={link?.path}>
                    <p
                      className={`${
                        matchRoutes(link?.path)
                          ? "text-yellow-25"
                          : "text-richblack-25"
                      }`}
                    >
                      {link?.title}
                    </p>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* login/signup/dashboard/cards  */}
        <div className="hidden items-center gap-x-4 md:flex">
          {
            user && user?.accountType != ACCOUNT_TYPE.Instructor && (
              <Link to="/dashboard/cart" className="relative">
                <CiShoppingCart className="text-2xl text-richblack-100"/>
                {
                  totalItems >0 && (
                    <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-yellow-100">
                      {totalItems}
                    </span>
                  )
                }
              </Link>
            )
          }
          {
            
             token ==null && (
              <Link to="/login">
                <button
                 className="rounded-[8px] border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100">
                  Log in
                </button>
               </Link>
            )
           }
           {
            token== null && (
              <Link to="/signup">
                <button className="rounded-[8px] border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100">
                  Sign up
                </button>
              </Link>
            )
           }
           {/* MERE END SE PENDING HAI  */}
            {
            token !== null && <ProfileDropdown/>
            } 
        </div>
        <button className="mr-4 md:hidden">
          <AiOutlineMenu fontSize={24} fill="#AFB2BF" />
        </button>
      </div>
    </div>
  );
};

export default Navbar;
